module.exports = __webpack_public_path__ + "img/flag-br.a679b973.png";